import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: [1, 'solid', theme.palette.colors.divider],
    padding: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      padding: theme.spacing(4),
      '& button': {
        display: 'none',
      },
      '&:hover': {
        backgroundColor: theme.palette.colors.lightGray,
        '& button': {
          display: 'unset',
        },
      },
    },
    height: 110,
  },
  mainBox: {
    display: 'flex',
    alignItems: 'center',
  },
  loanOfficerBadge: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 120,
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('mobile')]: {
      width: 160,
    },
  },
  name: {
    marginTop: 4,
  },
  infoBox: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    color: theme.palette.colors.darkBlueGray,
    marginTop: 4,
  },
  tag: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    '&:last-child': {
      marginRight: 0,
    },
  },
  companyLogo: {
    height: 30,
    width: 'auto',
    maxWidth: 80,
  },
  logoBox: {
    width: 80,
    marginRight: theme.spacing(2),
  },
  locationBadge: {
    width: 200,
  },
}));



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/LoanOfficersList/components/LoanOfficerCard/useStyles.js